export default {
  en: {
    checking: 'Checking…',
    checkButton: 'Check onboarding status',
    statusFormat: 'id {{id}} · onboarding {{onboarding}}',
    onboardingDone: 'done ✅',
    onboardingNotDone: 'not done',
  },
  ru: {
    checking: 'Проверяю…',
    checkButton: 'Проверить статус онбординга',
    statusFormat: 'id {{id}} · онбординг {{onboarding}}',
    onboardingDone: 'пройден ✅',
    onboardingNotDone: 'не пройден',
  },
  de: {
    checking: 'Prüfe…',
    checkButton: 'Onboarding-Status prüfen',
    statusFormat: 'id {{id}} · onboarding {{onboarding}}',
    onboardingDone: 'abgeschlossen ✅',
    onboardingNotDone: 'nicht abgeschlossen',
  },
  pt: {
    checking: 'Verificando…',
    checkButton: 'Verificar status do onboarding',
    statusFormat: 'id {{id}} · onboarding {{onboarding}}',
    onboardingDone: 'concluído ✅',
    onboardingNotDone: 'não concluído',
  },
  fr: {
    checking: 'Vérification…',
    checkButton: 'Vérifier le statut de l’onboarding',
    statusFormat: 'id {{id}} · onboarding {{onboarding}}',
    onboardingDone: 'terminé ✅',
    onboardingNotDone: 'non terminé',
  },
  es: {
    checking: 'Comprobando…',
    checkButton: 'Comprobar el estado del onboarding',
    statusFormat: 'id {{id}} · onboarding {{onboarding}}',
    onboardingDone: 'completado ✅',
    onboardingNotDone: 'no completado',
  },
};
